import React from 'react'
import RadioButtunTable from '../../CommonUtils/RadioButtunTable/RadioButtunTable'

function MessageA3Table(props) {
  return (
    <div>
       <RadioButtunTable {...props} />
    </div>
  )
}

export default MessageA3Table

